import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=2dfe6e90&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe6e90",
  null
  
)

component.options.__file = "src/demo/packageMall/cart.vue"
export default component.exports